<div class="w-min rounded-full px-4 py-1"
     [style]="{'background-color' : propertyValue + (isDarkTheme() ? 'FF' : '33') }">
    <span [style]="{'color' : (isDarkTheme() ? 'white' : textColor) }" class="font-bold">{{ propertyText }}</span>
</div>
